import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { allComics } from '@/mocks/comics';

interface LatestUpdatesProps {
  category: string | null;
}

export default function LatestUpdates({ category }: LatestUpdatesProps) {
  const filtered = category
    ? allComics.filter((c) => c.category === category)
    : allComics;

  const sorted = [...filtered].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );

  const display = sorted.slice(0, 12);

  return (
    <section className="py-14 bg-white" aria-labelledby="latest-heading">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <h2 id="latest-heading" className="font-heading text-2xl text-foreground-950">
            {category ? '分类最新' : '最新更新'}
          </h2>
          <Link
            to={category ? `/category/${category}` : '/category/lianai'}
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            查看更多
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5">
          {display.map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}